var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshiconHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_136)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "#D6DAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00071 19.0458C8.92274 19.4526 9.18932 19.8456 9.59613 19.9235C10.0029 20.0015 10.3959 19.7349 10.4739 19.3281L9.00071 19.0458ZM10.4739 19.3281C11.4104 14.442 15.7085 10.75 20.8673 10.75V9.25C14.9755 9.25 10.0701 13.4662 9.00071 19.0458L10.4739 19.3281ZM20.8673 10.75C26.0409 10.75 30.3489 14.4632 31.2687 19.3701L32.7431 19.0938C31.6927 13.4904 26.776 9.25 20.8673 9.25V10.75Z",
    fill: "#0A0D14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5432 23.3851C32.6212 22.9783 32.3546 22.5853 31.9478 22.5074C31.541 22.4294 31.148 22.696 31.07 23.1028L32.5432 23.3851ZM31.07 23.1028C30.1336 27.9889 25.8354 31.6809 20.6766 31.6809V33.1809C26.5684 33.1809 31.4738 28.9647 32.5432 23.3851L31.07 23.1028ZM20.6766 31.6809C15.503 31.6809 11.1951 27.9677 10.2752 23.0608L8.80089 23.3372C9.85129 28.9405 14.768 33.1809 20.6766 33.1809V31.6809Z",
    fill: "#0A0D14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9152 16.9445L32.1985 19.9179L29.2251 18.2012",
    stroke: "#0A0D14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6283 25.4863L9.34498 22.5129L12.3184 24.2296",
    stroke: "#0A0D14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshiconHome);
export default __webpack_public_path__ + "static/media/RefreshiconHome.ca03c00e5b768809f3016d58ca4a5edc.svg";
export { ForwardRef as ReactComponent };